import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ArrowLeftSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ArrowLeftSVG;
